/**
 * Group RogerDoc form types for the Forms Manager dropdown:
 * SOC family, then ROC, then REC, then DC, then everything else in its
 * existing order. Stable within each group. `DD*` is NOT a DC (prefix `DC`
 * requires the literal "DC"). EMR-191 item 13.
 */
const FAMILY_PREFIXES = ['SOC', 'ROC', 'REC', 'DC'] as const;

function familyRank(formType: string): number {
  for (let i = 0; i < FAMILY_PREFIXES.length; i++) {
    if (formType.startsWith(FAMILY_PREFIXES[i])) return i;
  }
  return FAMILY_PREFIXES.length;
}

export function sortFormTypeCatalogByFamily<T extends { form_type: string }>(
  rows: readonly T[]
): T[] {
  // Array.prototype.sort is stable in modern JS engines, so equal-rank rows
  // keep their input order.
  return [...rows].sort(
    (a, b) => familyRank(a.form_type) - familyRank(b.form_type)
  );
}
